"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _toDate = _interopRequireDefault(require("date-fns/toDate"));

var _fr = _interopRequireDefault(require("date-fns/locale/fr"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));

var _excluded = ["ioFormat", "id", "name", "value", "label", "placeholder", "helper", "floatLabel", "clearable", "locale", "withIcon", "calendarOnly", "readOnly", "disabled", "required", "onChange", "onBlur", "onError", "className", "minDate", "maxDate", "renderCustomHeader"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

(0, _reactDatepicker.registerLocale)('fr', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-FR', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-CA', _fr.default);

var dateShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]);

var inputFormat = function inputFormat(date, ioFormat) {
  if (date && (typeof date === 'number' || ioFormat.search('Timestamp') > -1)) {
    if (date.toString().length <= 10 || ioFormat === 'unixTimestamp') {
      // It's a UNIX Timestamp (in seconds)
      return (0, _toDate.default)(date * 1000);
    } // It's a JS Timestamp (in milliseconds)


    return (0, _toDate.default)(date);
  }

  if (date && (date instanceof Date || new Date(date) instanceof Date || ioFormat.search('Date') > -1)) {
    // It's a JS Date
    return (0, _toDate.default)(date);
  }

  if (date === 0) {
    // It's a Timestamp (in seconds or milliseconds)
    return (0, _toDate.default)(date);
  }

  return null;
};

var outputFormat = function outputFormat(date, dateRef, ioFormat) {
  if (date !== null && date !== undefined) {
    if (dateRef && typeof dateRef === 'number' || ioFormat.search('Timestamp') > -1) {
      if (dateRef && dateRef.toString().length <= 10 || ioFormat === 'unixTimestamp') {
        // As we get an UNIX Timestamp as input, we output an UNIX Timestamp too
        return Date.parse(date) / 1000;
      } // As we get a JS Timestamp as input, we output a JS Timestamp too


      return new Date(date).getTime();
    }

    if (dateRef && (dateRef instanceof Date || new Date(dateRef) instanceof Date) || ioFormat.search('Date') > -1) {
      return (0, _toDate.default)(date);
    }
  }

  return null;
};
/**
 * The DatePicker component allows an user to select a date and/or time in a determined format.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/Hacker0x01/react-datepicker/">React Datepicker</a>
 */


var InputDateRange = function InputDateRange(_ref) {
  var ioFormat = _ref.ioFormat,
      controlledId = _ref.id,
      name = _ref.name,
      controlledDate = _ref.value,
      initialLabel = _ref.label,
      placeholder = _ref.placeholder,
      helper = _ref.helper,
      floatLabel = _ref.floatLabel,
      clearable = _ref.clearable,
      locale = _ref.locale,
      withIcon = _ref.withIcon,
      calendarOnly = _ref.calendarOnly,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      required = _ref.required,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onError = _ref.onError,
      className = _ref.className,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      renderCustomHeader = _ref.renderCustomHeader,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var datePickerRangeStartRef = _react.default.useRef(null);

  var datePickerRangeEndRef = _react.default.useRef(null);

  var id = (0, _useRandomId.default)(controlledId);

  var _React$useState = _react.default.useState(controlledDate && controlledDate.length > 0 ? controlledDate[0] : null),
      startDate = _React$useState[0],
      setStartDate = _React$useState[1];

  var _React$useState2 = _react.default.useState(controlledDate && controlledDate.length > 1 ? controlledDate[1] : null),
      endDate = _React$useState2[0],
      setEndDate = _React$useState2[1];

  var labelClasses = (0, _clsx.default)(initialLabel && floatLabel ? 'float-label' : false, floatLabel ? 'filled' : false);

  var _useLabel = (0, _useLabel2.default)(initialLabel, id, labelClasses, required),
      label = _useLabel.label; // const [error, setError] = React.useState(false);


  var error = false; // const [calOnly, setCalOnly] = React.useState(false);
  // const [errors, methods] = useFormElementValidation(date, {
  //     required,
  //     date,
  // });
  // const [, errorsEndDate, methodsEndDate] = useFormElementValidation(endDate, {
  //     required,
  //     date: endDate,
  // });
  // React.useEffect(() => setDate(prepareInput(controlledDate)), [controlledDate]);

  _react.default.useEffect(function () {
    if (controlledDate) {
      setStartDate(inputFormat(controlledDate[0], ioFormat));
      setEndDate(inputFormat(controlledDate[1], ioFormat));
    }
  }, [controlledDate, ioFormat]); // React.useEffect(() => {
  //     // console.log(new Set([errors, errorsEndDate]));
  //     setError(errors.length > 0 || errorsEndDate.length > 0);
  //     if (typeof onError === 'function') {
  //         onError({ name: datePickerRef.current.props.name, errors: errors.length ? errors : [] });
  //         onError({ name: datePickerRangeEndRef.current.props.name, errors: errorsEndDate.length ? errorsEndDate : [] });
  //     }
  // }, [errors, errorsEndDate, onError]);


  var handleChange = function handleChange(updatedDate) {
    setStartDate(updatedDate[0]);
    setEndDate(updatedDate[1]);

    if (typeof onChange === 'function') {
      var controlledDateStart = controlledDate && controlledDate.length > 0 ? controlledDate[0] : null;
      var controlledDateEnd = controlledDate && controlledDate.length > 1 ? controlledDate[1] : null;
      onChange([outputFormat(updatedDate[0], controlledDateStart, ioFormat), outputFormat(updatedDate[1], controlledDateEnd, ioFormat)]);
    }
  };

  var handleOnClear = function handleOnClear() {
    // methods.onChangeDate(null);
    setStartDate(null);
    setEndDate(null);

    if (typeof onChange === 'function') {
      onChange([null, null]);
    }
  };

  var handleClickOutside = function handleClickOutside() {
    datePickerRangeStartRef.current.setOpen(false);
    datePickerRangeEndRef.current.setOpen(false);
  }; // const handleBlur = (event) => {
  //     handleClickOutside();
  //     methods.onChangeDate(date);
  //     methodsEndDate.onChangeDate(endDate);
  //     if (typeof onBlur === 'function') {
  //         onBlur(event);
  //     }
  // };


  var containerClasses = (0, _clsx.default)('uk-input', 'uk-datepicker', 'uk-datepicker--range', helper.length > 0 || error ? 'has-helper' : '', error ? 'has-error' : '', className);

  var getPlaceholderText = function getPlaceholderText(placeHolder) {
    return placeHolder || (locale && locale.split('-')[0] === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy');
  };

  var getStringContent = function getStringContent(value, isRight) {
    if (value && Array.isArray(value) && value.length > 0) {
      if (isRight && value.length > 1) return value[1];
      return value[0];
    } else if (typeof value === 'string' || value instanceof String) {
      return value;
    }

    return undefined;
  };

  var placeholderLeft = getStringContent(placeholder);
  var placeholderRight = getStringContent(placeholder, true);
  var renderCustomHeaderLeft = getStringContent(renderCustomHeader);
  var renderCustomHeaderRight = getStringContent(renderCustomHeader, true);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    className: "rangeStart",
    ref: datePickerRangeStartRef,
    id: id + "-rangeStart",
    name: name ? name + "-rangeStart" : id + "-rangeStart",
    selected: startDate,
    placeholderText: getPlaceholderText(placeholderLeft),
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: function onChange(updatedDate) {
      return handleChange([updatedDate, endDate || null]);
    },
    onClickOutside: handleClickOutside // onBlur={handleBlur}
    ,
    startDate: startDate,
    endDate: endDate,
    minDate: minDate,
    maxDate: endDate || maxDate,
    selectsStart: true,
    tabIndex: 0,
    popperPlacement: "bottom-start",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport'
      }
    }],
    locale: locale ? locale.split('-')[0] : null,
    dateFormat: locale && locale.split('-')[0] === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy',
    renderCustomHeader: renderCustomHeaderLeft
  }, attributes)), /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    className: "rangeEnd",
    ref: datePickerRangeEndRef,
    id: id + "-rangeEnd",
    name: name ? name + "-rangeEnd" : id + "-rangeEnd",
    selected: endDate,
    placeholderText: getPlaceholderText(placeholderRight),
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: function onChange(updatedDate) {
      return handleChange([startDate || null, updatedDate]);
    },
    onClickOutside: handleClickOutside // onBlur={handleBlur}
    ,
    selectsEnd: true,
    startDate: startDate,
    endDate: endDate,
    minDate: startDate || minDate,
    maxDate: maxDate,
    tabIndex: 0,
    popperPlacement: "bottom-end",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport'
      }
    }],
    locale: locale ? locale.split('-')[0] : null,
    dateFormat: locale && locale.split('-')[0] === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy',
    renderCustomHeader: renderCustomHeaderRight
  }, attributes)), withIcon && !(startDate || endDate) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "calendar"
  }), clearable && (startDate || endDate) && /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": "true",
    className: "uk-input__clearButton",
    onClick: handleOnClear
  }, "\xD7")));
};

InputDateRange.propTypes = {
  /**
   * Format of in/out date
   */
  ioFormat: _propTypes.default.string,

  /**
   * ID of the DatePicker (used to bind the label to its input field)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,

  /**
   * Name of the DatePicker (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,

  /**
   * Default value of the DatePicker
   */
  value: _propTypes.default.arrayOf(dateShape),

  /**
   * Label of the DatePicker
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * DatePicker placeholder
   */
  placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),

  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,

  /**
   * Remove the placeholder (if any), replace it with a floating label
   */
  floatLabel: _propTypes.default.bool,

  /**
   * Set the date formatting depending on the locale
   * (e.g. 'en', 'en-CA', 'en_CA', etc.)
   */
  locale: _propTypes.default.oneOf(['en', 'fr']),

  /**
   * Add a decorative calendar icon to the DatePicker
   */
  withIcon: _propTypes.default.bool,

  /**
   * Add a button to clear the DatePicker
   */
  clearable: _propTypes.default.bool,

  /**
   * Set the DatePicker as read-only
   */
  calendarOnly: _propTypes.default.bool,

  /**
   * Set the DatePicker as read-only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Set the DatePicker as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Form-validation: set the DatePicker as required
   */
  required: _propTypes.default.bool,

  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function onError
   */
  onError: _propTypes.default.func
};
InputDateRange.defaultProps = {
  value: [null, null],
  ioFormat: 'jsDate',
  placeholder: '',
  helper: '',
  floatLabel: false,
  withIcon: true,
  calendarOnly: false,
  readOnly: false,
  disabled: false,
  required: false,
  clearable: false
};
var _default = InputDateRange;
exports.default = _default;